import { createContext, useContext } from 'react'

export const SidebarOpenContext = createContext(true)

/** False on the collapsed rail, where rows show their icon alone. */
export function useSidebarOpen(): boolean {
  return useContext(SidebarOpenContext)
}
